import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import Icon from "../Icon";
import "./IconHeader.scss";
import { EGIconButton } from "../../MainComponents/Button/IconButton/IconButton";

export const IconHeader = ({
  iconName = "",
  iconButtonName = "",
  title = "",
  button = false,
  buttonAction = () => {},
  fontSize = 12,
  variant = "h5",
  fontWeight = 600,
  uppercase = true,
  buttonColor = "",
  iconColor = "",
  iconColorHover = "",
  iconSize = 22,
  iconTitle = "",
  buttonColorHover = "",
  ...rest
}) => {
  const theme = useTheme();
  return (
    <Stack
      rest={rest}
      display="flex"
      alignItems="center"
      justifyContent="space-evenly"
      flexDirection="row"
      spacing={1.5}
      padding={0}
    >
      {iconName && (
        <Box className="icon-Header">
          <Icon
            name={iconName}
            color={theme.palette.secondary.main}
            size={20}
          />
        </Box>
      )}
      <Typography
        variant={variant}
        color="primary"
        fontSize={fontSize}
        fontWeight={fontWeight}
      >
        {uppercase ? title.toLocaleUpperCase() : title}
      </Typography>
      <Box
        sx={{
          flexGrow: 1,
          borderBottom: `2px solid ${theme.palette.primary.main}`,
        }}
      />
      {button && (
        <EGIconButton
          color={buttonColor}
          iconName={iconButtonName}
          iconColor={iconColor}
          iconColorHover={iconColorHover}
          onClick={typeof buttonAction === "function" ? buttonAction : () => {}}
          iconSize={iconSize}
          title={iconTitle}
          colorHover={buttonColorHover}
        />
      )}
    </Stack>
  );
};
